import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Box, Grid, Typography } from "@material-ui/core";
import "./Chart.css";

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: "#CDE7FF",
    margin: "16px 0",
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

// progressbar 2
const BorderLinearProgress2 = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: "#8CFAC7",
    margin: "18px 0",
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#00E096",
  },
}))(LinearProgress);

// progressbar 3
const BorderLinearProgress3 = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: "#C5A8FF",
    margin: "19px 0",
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#884DFF",
  },
}))(LinearProgress);

// progressbar 4
const BorderLinearProgress4 = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: "#FFD5A4",
    margin: "21px 0",
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#FF8F0D",
  },
}))(LinearProgress);

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    margin: "30px 0",
  },
});
const TopCustomer = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h5" className="adminHomeTitle">
        Top Customer
      </Typography>
      <Grid
        container
        spacing={2}
        className={classes.salesSummery}
        style={{ paddingTop: "30px" }}
      >
        <Grid item xs={12} lg={4} md={12}>
          <Typography variant="span" className="topCustomerTitle">
            Name
          </Typography>
          <Box className="customerNameContainer">
            <Typography variant="h5" className="customerName">
              Unilever
            </Typography>
            <Typography variant="h5" className="customerName">
              P&G
            </Typography>
            <Typography variant="h5" className="customerName">
              Daltex
            </Typography>
            <Typography variant="h5" className="customerName">
              Al Futtaim Motors
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} lg={6} md={12}>
          <Typography variant="span" className="topCustomerTitle">
            Popularity by conversion
          </Typography>{" "}
          <Box className="progresBar">
            <Box className="progressbar">
              <BorderLinearProgress variant="determinate" value={60} />
            </Box>
            <Box className="progressbar">
              <BorderLinearProgress2 variant="determinate" value={100} />
            </Box>
            <Box className="progressbar">
              <BorderLinearProgress3 variant="determinate" value={40} />
            </Box>
            <Box className="progressbar">
              <BorderLinearProgress4 variant="determinate" value={30} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} lg={2} md={12}>
          <Typography variant="span" className="topCustomerTitle">
            Sales( USD)
          </Typography>
          <Box className="customerButton">
            <button className="customer-button1">45</button>

            <button className="customer-button2">32</button>

            <button className="customer-button3">18</button>

            <button className="customer-button4">22</button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default TopCustomer;
